import React from 'react';
import { Check, Star } from 'lucide-react';
import { packages } from '../mock';
import { Button } from './ui/button';

const Packages = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="packages" className="py-20 bg-slate-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-orange-600 font-semibold text-sm uppercase tracking-wider">Our Packages</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-4 mb-4">
            Explore Our Popular <span className="text-orange-600">Packages Now</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Choose the perfect package that suits your budget and requirements
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {packages.map((pkg) => (
            <div
              key={pkg.id}
              className={`relative bg-white rounded-2xl shadow-lg overflow-hidden transition-all duration-300 ${
                pkg.popular
                  ? 'ring-2 ring-orange-600 transform lg:scale-105 z-10'
                  : 'hover:shadow-xl hover:-translate-y-2'
              }`}
            >
              {pkg.popular && (
                <div className="absolute top-0 right-0 bg-orange-600 text-white px-4 py-2 text-sm font-bold rounded-bl-2xl flex items-center space-x-1">
                  <Star className="w-4 h-4" fill="currentColor" />
                  <span>POPULAR</span>
                </div>
              )}

              <div className="p-8 space-y-6">
                {/* Header */}
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{pkg.name}</h3>
                  <p className="text-gray-600">{pkg.description}</p>
                </div>

                {/* Price */}
                <div className="py-6 border-y border-gray-200">
                  <div className="flex items-baseline">
                    <span className="text-5xl font-bold text-orange-600">₹{pkg.price}</span>
                    <span className="text-gray-600 ml-2">/sq. ft*</span>
                  </div>
                </div>

                {/* Features */}
                <ul className="space-y-3">
                  {pkg.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center space-x-3">
                      <div className="flex-shrink-0 w-5 h-5 rounded-full bg-orange-100 flex items-center justify-center">
                        <Check className="w-3 h-3 text-orange-600" />
                      </div>
                      <span className="text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>

                {/* CTA */}
                <Button
                  onClick={scrollToContact}
                  className={`w-full ${
                    pkg.popular
                      ? 'bg-orange-600 hover:bg-orange-700 text-white'
                      : 'bg-slate-100 hover:bg-orange-600 text-gray-900 hover:text-white'
                  }`}
                >
                  Get Started
                </Button>
              </div>
            </div>
          ))}
        </div>

        {/* Green Home Section */}
        <div className="mt-20 bg-gradient-to-br from-green-50 to-emerald-50 rounded-3xl p-12">
          <div className="text-center mb-12">
            <h3 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Eco Friendly <span className="text-green-600">Green Home Construction</span>
            </h3>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Build sustainable homes that are good for you and the environment
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl p-6 shadow-md">
              <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center mb-4">
                <Check className="w-6 h-6 text-green-600" />
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-2">Good Perspective</h4>
              <p className="text-gray-600">Technical knowledge and expertise in green home construction</p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-md">
              <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center mb-4">
                <Check className="w-6 h-6 text-green-600" />
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-2">Energy Efficient</h4>
              <p className="text-gray-600">Designs that minimize environmental impact and reduce costs</p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-md">
              <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center mb-4">
                <Check className="w-6 h-6 text-green-600" />
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-2">Cost Efficient</h4>
              <p className="text-gray-600">Eco-friendly materials that reduce long-term maintenance costs</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Packages;